(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["subscription-purchase"] && !Shopify.designMode) return;
  try {
    (function () {
    const blocks = document.querySelectorAll('[data-sub-purchase]');
    blocks.forEach(initBlock);

    function initBlock(root) {
      const options = root.querySelectorAll('[data-sub-option]');
      const hidden = root.querySelector('[data-sub-hidden]');
      const chips = root.querySelectorAll('[data-sub-chip]');
      const freqSelect = root.querySelector('[data-sub-freq-select]');
      const priceSubEl = root.querySelector('[data-sub-price-sub]');
      const subRadio = root.querySelector('[data-sub-radio="subscribe"]');
      const oneRadio = root.querySelector('[data-sub-radio="onetime"]');

      // Frequency picker renders as chips (few plans) or a select (many plans).
      function activePlan() {
        if (freqSelect) {
          const opt = freqSelect.options[freqSelect.selectedIndex];
          return opt ? { id: opt.value, key: opt.value, price: opt.dataset.subPlanPrice } : null;
        }
        const chip = root.querySelector('[data-sub-chip].is-active') || chips[0];
        return chip
          ? { id: chip.dataset.subPlanId, key: chip.dataset.subPlanKey || chip.dataset.subPlanId, price: chip.dataset.subPlanPrice }
          : null;
      }

      function setActiveOption(kind) {
        options.forEach(o => o.classList.toggle('is-active', o.dataset.subOption === kind));
        let planKey = '';
        if (kind === 'subscribe') {
          const plan = activePlan();
          if (plan && hidden) hidden.value = plan.id;
          if (plan) planKey = plan.key;
        } else if (hidden) {
          hidden.value = '';
        }
        root.dispatchEvent(new CustomEvent('sub:change', { bubbles: true, detail: { kind, planId: hidden ? hidden.value : '', planKey } }));
      }

      function updateSubPrice() {
        if (!priceSubEl) return;
        const plan = activePlan();
        if (!plan) return;
        const cents = parseInt(plan.price, 10);
        if (!isNaN(cents)) priceSubEl.textContent = formatMoney(cents);
      }

      options.forEach(opt => {
        opt.addEventListener('click', (e) => {
          if (e.target.closest('[data-sub-chip], .sub-purchase__unit, .sub-purchase__freq-select, .sub-purchase__freq-grouped')) return;
          const radio = opt.querySelector('input[type="radio"]');
          if (radio) radio.checked = true;
          setActiveOption(opt.dataset.subOption);
        });
      });

      chips.forEach(chip => {
        chip.addEventListener('click', () => {
          chips.forEach(c => {
            c.classList.remove('is-active');
            c.setAttribute('aria-checked', 'false');
          });
          chip.classList.add('is-active');
          chip.setAttribute('aria-checked', 'true');
          updateSubPrice();
          if (subRadio) {
            subRadio.checked = true;
            setActiveOption('subscribe');
          }
        });
      });

      if (freqSelect) {
        freqSelect.addEventListener('change', () => {
          updateSubPrice();
          if (subRadio) {
            subRadio.checked = true;
            setActiveOption('subscribe');
          }
        });
        initGroupedFreq(freqSelect);
      }

      // Upgrade the flat frequency select into unit tabs (Days/Weeks/Months)
      // + an "Every N ..." select. Plan cadence comes from Recharge option
      // values ("30-day") when present, otherwise from the plan name
      // ("Delivery every 30 days", "1 week", "7 day subscription").
      // The original select stays as the state holder for selling_plan,
      // prices and the sticky bar.
      function initGroupedFreq(select) {
        const UNITS = ['day', 'week', 'month', 'year'];
        const UNIT_LABELS = { day: 'Days', week: 'Weeks', month: 'Months', year: 'Years' };

        function parsePlan(opt) {
          const fromData = (opt.dataset.subUnit || '').toLowerCase().replace(/s$/, '');
          const fromInterval = parseInt(opt.dataset.subInterval, 10);
          if (UNITS.indexOf(fromData) !== -1 && fromInterval > 0) {
            return { n: fromInterval, unit: fromData, value: opt.value };
          }
          const text = (opt.textContent || '').trim();
          let m = text.match(/(\d+)\s*-?\s*(days?|weeks?|months?|years?)\b/i);
          if (m) {
            return { n: parseInt(m[1], 10), unit: m[2].toLowerCase().replace(/s$/, ''), value: opt.value };
          }
          m = text.match(/\bevery\s+(day|week|month|year)\b/i);
          if (m) {
            return { n: 1, unit: m[1].toLowerCase(), value: opt.value };
          }
          return null;
        }

        const buckets = {};
        Array.from(select.options).forEach(opt => {
          const parsed = parsePlan(opt);
          if (!parsed) return;
          buckets[parsed.unit] = buckets[parsed.unit] || [];
          buckets[parsed.unit].push(parsed);
        });
        const units = UNITS.filter(u => buckets[u] && buckets[u].length);
        const parsedCount = units.reduce((n, u) => n + buckets[u].length, 0);
        if (parsedCount < 2) {
          const wrap = select.closest('.sub-purchase__freq-wrap');
          if (wrap) wrap.classList.add('is-ready');
          return;
        }
        units.forEach(u => buckets[u].sort((a, b) => a.n - b.n));

        const popularValue = select.options.length ? select.options[0].value : null;
        const wrap = select.closest('.sub-purchase__freq-wrap') || select;
        const host = wrap.parentNode;
        const ui = document.createElement('span');
        ui.className = 'sub-purchase__freq-grouped';

        const numWrap = document.createElement('span');
        numWrap.className = 'sub-purchase__freq-wrap';
        const numSelect = document.createElement('select');
        numSelect.className = 'sub-purchase__freq-select';
        numSelect.setAttribute('aria-label', 'Delivery frequency');
        numWrap.appendChild(numSelect);

        let unitBtns = [];
        if (units.length > 1) {
          const unitRow = document.createElement('span');
          unitRow.className = 'sub-purchase__freq-units';
          unitRow.setAttribute('role', 'radiogroup');
          unitRow.setAttribute('aria-label', 'Delivery schedule unit');
          unitBtns = units.map(unit => {
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'sub-purchase__unit';
            btn.setAttribute('role', 'radio');
            btn.setAttribute('aria-checked', 'false');
            btn.textContent = UNIT_LABELS[unit] || (unit.charAt(0).toUpperCase() + unit.slice(1) + 's');
            btn.addEventListener('click', (e) => {
              e.preventDefault();
              setUnit(unit, true);
            });
            unitRow.appendChild(btn);
            return { unit, btn };
          });
          ui.appendChild(unitRow);
        }

        function setUnit(unit, userDriven) {
          unitBtns.forEach(({ unit: u, btn }) => {
            const active = u === unit;
            btn.classList.toggle('is-active', active);
            btn.setAttribute('aria-checked', active ? 'true' : 'false');
          });
          numSelect.innerHTML = '';
          buckets[unit].forEach(({ n, value }) => {
            const o = document.createElement('option');
            o.value = value;
            o.textContent = n === 1 ? 'Every ' + unit : 'Every ' + n + ' ' + unit + 's';
            if (value === popularValue) o.textContent += ' \u00b7 Most popular';
            numSelect.appendChild(o);
          });
          if (userDriven) {
            const preferred = buckets[unit].find(p => p.value === popularValue);
            if (preferred) numSelect.value = preferred.value;
            sync();
          }
        }

        function sync() {
          select.value = numSelect.value;
          select.dispatchEvent(new Event('change'));
        }

        numSelect.addEventListener('change', sync);

        const current = select.value;
        const startUnit = units.find(u => buckets[u].some(p => p.value === current)) || units[0];
        setUnit(startUnit, false);
        numSelect.value = current;
        if (numSelect.selectedIndex < 0) numSelect.selectedIndex = 0;

        ui.appendChild(numWrap);
        host.insertBefore(ui, wrap);
        wrap.hidden = true;
        wrap.classList.add('is-ready');
      }

      // Initial sync.
      const initialKind = subRadio && subRadio.checked ? 'subscribe' : (oneRadio && oneRadio.checked ? 'onetime' : 'onetime');
      setActiveOption(initialKind);
    }

    function formatMoney(cents) {
      const value = (cents / 100).toFixed(2);
      const fmt = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
          style: 'currency',
          currency: fmt
        }).format(value);
      } catch (e) {
        return '\u00a3' + value;
      }
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variety-pack-builder"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.querySelector('[data-vpb]');
    if (!root) return;

    var startersEl = root.querySelector('[data-vpb-starters]');
    var starters = [];
    try { starters = JSON.parse(startersEl.textContent); } catch (e) { return; }
    if (!starters.length) return;

    var byKey = {};
    starters.forEach(function (s) { byKey[s.key] = s; });

    // If the store has duplicate starter products, the deduped list may point
    // at a sibling duplicate rather than the product actually being viewed -
    // patch the current key back to this page's product so prices/plans match.
    var currentKey = root.dataset.currentKey;
    if (!byKey[currentKey] || byKey[currentKey].handle !== root.dataset.currentHandle) {
      byKey[currentKey] = {
        key: currentKey,
        label: '',
        handle: root.dataset.currentHandle,
        url: root.dataset.currentUrl,
        price: parseInt(root.dataset.currentPrice, 10) || 0,
        subPrice: parseInt(root.dataset.currentSubPrice, 10) || 0,
        planId: root.dataset.currentPlanId || '',
        planName: ''
      };
    }

    var idSelect = root.querySelector('[data-vpb-id]');
    var form = root.querySelector('.js-vpb-form');
    var atc = root.querySelector('[data-vpb-atc]');
    var atcText = root.querySelector('[data-vpb-atc-text]');
    var priceEl = root.querySelector('[data-vpb-price]');
    var savingsEl = root.querySelector('[data-vpb-savings]');
    var savingsAmtEl = root.querySelector('[data-vpb-savings-amt]');
    var announceEl = root.querySelector('[data-vpb-announce]');
    var subWidget = root.querySelector('[data-sub-purchase]');
    var planHidden = form ? form.querySelector('[name="selling_plan"]') : null;

    var state = {
      starter: byKey[currentKey],
      v2: null,
      v3: null,
      matrices: {},
      fetchToken: 0
    };

    // Parse the server-rendered variant select into the current product's
    // option2/option3 -> variant matrix.
    (function () {
      var map = {};
      Array.prototype.forEach.call(idSelect.options, function (o) {
        var parts = (o.dataset.variantOptions || '').split('||');
        if (parts.length < 3) return;
        map[parts[1] + '||' + parts[2]] = {
          id: o.value,
          available: o.dataset.variantAvailable === 'true',
          price: parseInt(o.dataset.variantPrice, 10)
        };
      });
      state.matrices[root.dataset.currentHandle] = map;
    })();

    function money(cents) {
      var val = (cents / 100).toFixed(2);
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
          style: 'currency',
          currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP'
        }).format(val);
      } catch (e) {
        return '\u00a3' + val;
      }
    }

    function group(n) {
      if (n === 1) return root.querySelector('[data-vpb-chips="1"]');
      return root.querySelector('[data-vpb-chips="' + n + '"][data-group="' + state.starter.key + '"]')
        || root.querySelector('[data-vpb-chips="' + n + '"]:not([hidden])');
    }

    function activeChip(n) {
      var g = group(n);
      return g ? g.querySelector('.is-active') : null;
    }

    function setActive(g, chip) {
      if (!g || !chip) return;
      Array.prototype.forEach.call(g.querySelectorAll('.vpb__chip'), function (c) {
        var on = c === chip;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    }

    function setSlot(n, chip) {
      var slot = root.querySelector('[data-vpb-slot="' + n + '"]');
      if (!slot || !chip) return;
      var img = slot.querySelector('[data-vpb-slot-img]');
      var name = slot.querySelector('[data-vpb-slot-name]');
      if (img && chip.dataset.img) img.src = chip.dataset.img;
      if (name) name.textContent = chip.dataset.value;
      slot.classList.remove('is-popping');
      void slot.offsetWidth;
      slot.classList.add('is-popping');
    }

    // ---- Accordion steps: pick -> lock in (compact row) -> next step opens ----
    var stepDone = { 1: false, 2: false, 3: false };

    function stepEl(n) {
      return root.querySelector('[data-vpb-step-wrap="' + n + '"]');
    }

    function openStep(n) {
      [1, 2, 3].forEach(function (i) {
        var el = stepEl(i);
        if (!el) return;
        var open = i === n;
        el.classList.toggle('is-open', open);
        var slot = root.querySelector('[data-vpb-slot="' + i + '"]');
        if (slot) slot.classList.toggle('is-active', open);
        var t = el.querySelector('[data-vpb-step-toggle]');
        if (t) t.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    function advanceFrom(n) {
      stepDone[n] = true;
      var el = stepEl(n);
      if (el) el.classList.add('is-done');
      var next = [1, 2, 3].filter(function (i) { return !stepDone[i]; })[0];
      if (next) {
        openStep(next);
      } else {
        openStep(0);
        if (form && typeof form.scrollIntoView === 'function') {
          form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    }

    Array.prototype.forEach.call(root.querySelectorAll('[data-vpb-slot]'), function (slot) {
      function go() {
        var n = parseInt(slot.dataset.vpbSlot, 10);
        openStep(n);
        var el = stepEl(n);
        if (el && window.matchMedia && window.matchMedia('(max-width: 900px)').matches && typeof el.scrollIntoView === 'function') {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
      slot.addEventListener('click', go);
      slot.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); }
      });
    });

    Array.prototype.forEach.call(root.querySelectorAll('[data-vpb-step-toggle]'), function (btn) {
      btn.addEventListener('click', function () {
        var n = parseInt(btn.dataset.vpbStepToggle, 10);
        var el = stepEl(n);
        if (el && el.classList.contains('is-open')) openStep(0);
        else openStep(n);
      });
    });

    function subscribed() {
      return !!(planHidden && planHidden.value);
    }

    function activePrice() {
      return subscribed() ? state.starter.subPrice : state.starter.price;
    }

    function matrix() {
      return state.matrices[state.starter.handle] || null;
    }

    function resolveEntry() {
      var m = matrix();
      if (!m || state.v2 === null || state.v3 === null) return null;
      return m[state.v2 + '||' + state.v3] || null;
    }

    function loadMatrix(handle) {
      if (state.matrices[handle]) return Promise.resolve(state.matrices[handle]);
      return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var map = {};
          (j.variants || []).forEach(function (v) {
            map[v.option2 + '||' + v.option3] = { id: String(v.id), available: !!v.available, price: v.price };
          });
          state.matrices[handle] = map;
          return map;
        });
    }

    function syncForm(entry) {
      if (!entry) return;
      // Rebuild rather than search: after a starter switch the select's
      // server-rendered options belong to a different product.
      idSelect.innerHTML = '';
      var o = document.createElement('option');
      o.value = entry.id;
      o.selected = true;
      idSelect.appendChild(o);
    }

    function syncUrl(entry) {
      try {
        // On the standalone pack-builder page keep the page URL and encode
        // the starter as ?starter=<handle>; on a PDP mirror the sibling URL.
        var url = root.dataset.baseUrl
          ? root.dataset.baseUrl + '?starter=' + encodeURIComponent(state.starter.handle)
          : state.starter.url + (entry ? '?variant=' + entry.id : '');
        window.history.replaceState({}, '', url);
      } catch (e) { /* noop */ }
    }

    function updateSavings() {
      if (!savingsEl || !savingsAmtEl) return;
      var sum = 0;
      var ok = true;
      [1, 2, 3].forEach(function (n) {
        var chip = activeChip(n);
        var p = chip ? parseInt(chip.dataset.bagPrice, 10) : 0;
        if (!p) ok = false;
        sum += p || 0;
      });
      var saving = sum - state.starter.price;
      if (ok && saving > 0) {
        savingsAmtEl.textContent = money(saving);
        savingsEl.hidden = false;
      } else {
        savingsEl.hidden = true;
      }
    }

    function refreshAvailability() {
      var m = matrix();
      [2, 3].forEach(function (n) {
        var g = group(n);
        if (!g) return;
        Array.prototype.forEach.call(g.querySelectorAll('[data-vpb-flavor]'), function (chip) {
          var key = n === 2
            ? chip.dataset.value + '||' + state.v3
            : state.v2 + '||' + chip.dataset.value;
          var entry = m ? m[key] : null;
          chip.classList.toggle('is-soldout', !!m && (!entry || !entry.available));
        });
      });
    }

    function updatePurchaseUI() {
      var entry = resolveEntry();
      var m = matrix();
      var loading = !m;

      if (priceEl) priceEl.textContent = money(state.starter.price);

      if (subWidget) {
        var onetimePrice = subWidget.querySelector('[data-sub-price-onetime]');
        if (onetimePrice) {
          var note = onetimePrice.querySelector('.sub-purchase__price-note');
          onetimePrice.textContent = money(state.starter.price) + ' ';
          if (!note) {
            note = document.createElement('span');
            note.className = 'sub-purchase__price-note';
            note.textContent = '+ delivery';
          }
          onetimePrice.appendChild(note);
        }
        var subPrice = subWidget.querySelector('[data-sub-price-sub]');
        if (subPrice) subPrice.textContent = money(state.starter.subPrice);
      }

      var stickyPrice = root.querySelector('[data-vpb-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = money(activePrice()) + (subscribed() ? '' : ' + delivery');

      if (atc && atcText) {
        if (loading) {
          atc.disabled = true;
          atcText.textContent = 'Loading flavours...';
        } else if (!entry) {
          atc.disabled = true;
          atcText.textContent = "That combo isn't available - try another bag";
        } else if (!entry.available) {
          atc.disabled = true;
          atcText.textContent = 'Sold out - try another bag';
        } else {
          atc.disabled = false;
          atcText.textContent = 'Add my pack \u00b7 ' + money(activePrice());
        }
      }
      var stickyAtc = root.querySelector('[data-vpb-sticky-atc]');
      if (stickyAtc && atc) {
        stickyAtc.disabled = atc.disabled;
        stickyAtc.textContent = atc.disabled && !loading ? 'Unavailable' : 'Add to cart';
      }
    }

    function announce(text) {
      if (announceEl) announceEl.textContent = text;
    }

    function afterSelectionChange() {
      var entry = resolveEntry();
      if (entry) {
        syncForm(entry);
        syncUrl(entry);
      }
      refreshAvailability();
      updateSavings();
      updatePurchaseUI();
      [1, 2, 3].forEach(function (n) {
        var chip = activeChip(n);
        if (!chip) return;
        var chosen = root.querySelector('[data-vpb-chosen="' + n + '"]');
        if (chosen) chosen.textContent = chip.dataset.value;
        var thumb = root.querySelector('[data-vpb-step-thumb="' + n + '"]');
        if (thumb && chip.dataset.img) thumb.src = chip.dataset.img;
      });
    }

    // ---- Step 2/3 flavour chips ----
    root.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-vpb-flavor]');
      if (!chip || !root.contains(chip)) return;
      var g = chip.closest('[data-vpb-chips]');
      var n = parseInt(g.dataset.vpbChips, 10);
      setActive(g, chip);
      if (n === 2) state.v2 = chip.dataset.value;
      if (n === 3) state.v3 = chip.dataset.value;
      setSlot(n, chip);
      announce((n === 2 ? '2nd' : '3rd') + ' bag: ' + chip.dataset.value);
      afterSelectionChange();
      advanceFrom(n);
    });

    // ---- Step 1: starter switch (sibling product, in place) ----
    root.addEventListener('click', function (e) {
      var link = e.target.closest('[data-vpb-starter]');
      if (!link || !root.contains(link)) return;
      e.preventDefault();
      var key = link.dataset.vpbStarter;
      if (!byKey[key] || key === state.starter.key) return;

      var prev2 = activeChip(2);
      var prev3 = activeChip(3);
      state.starter = byKey[key];

      setActive(group(1), link);
      setSlot(1, link);

      // Reveal this starter's chip groups; carry flavour choices across when
      // the sibling offers the same flavour, else fall back to its first chip.
      [2, 3].forEach(function (n) {
        Array.prototype.forEach.call(root.querySelectorAll('[data-vpb-chips="' + n + '"][data-group]'), function (g) {
          g.hidden = g.dataset.group !== key;
        });
        var g = group(n);
        if (!g) return;
        var want = n === 2 ? prev2 : prev3;
        var chip = null;
        if (want) {
          chip = Array.prototype.find.call(g.querySelectorAll('[data-vpb-flavor]'), function (c) {
            return c.dataset.fkey === want.dataset.fkey;
          }) || null;
        }
        chip = chip || g.querySelector('[data-vpb-flavor]');
        setActive(g, chip);
        if (chip) {
          if (n === 2) state.v2 = chip.dataset.value;
          if (n === 3) state.v3 = chip.dataset.value;
          setSlot(n, chip);
        }
      });

      remapPlans();
      announce('1st bag: ' + link.dataset.value);
      updatePurchaseUI();
      syncUrl(null);
      advanceFrom(1);

      var token = ++state.fetchToken;
      loadMatrix(state.starter.handle)
        .then(function () {
          if (token !== state.fetchToken) return;
          afterSelectionChange();
        })
        .catch(function () {
          if (token !== state.fetchToken) return;
          // Full navigation as a fallback if the sibling JSON can't load.
          window.location.href = state.starter.url;
        });
    });

    // Selling plan ids are per-product (Recharge), so point the widget's
    // one subscribe plan at the new starter's plan id and price.
    function remapPlans() {
      var newId = state.starter.planId || '';
      if (subWidget) {
        var subRadio = subWidget.querySelector('[data-sub-radio="subscribe"]');
        if (subRadio) {
          subRadio.value = newId;
          subRadio.dataset.subPlanId = newId;
        }
        Array.prototype.forEach.call(subWidget.querySelectorAll('[data-sub-chip]'), function (chip) {
          chip.dataset.subPlanId = newId;
          chip.dataset.subPlanKey = newId;
          chip.dataset.subPlanPrice = String(state.starter.subPrice);
          if (state.starter.planName) chip.textContent = state.starter.planName;
        });
        Array.prototype.forEach.call(subWidget.querySelectorAll('[data-sub-freq-select] option'), function (opt) {
          opt.value = newId;
          opt.dataset.subPlanPrice = String(state.starter.subPrice);
        });
      }
      if (planHidden && planHidden.value !== '') planHidden.value = newId;
    }

    // ---- Shuffle ----
    var shuffle = root.querySelector('[data-vpb-shuffle]');
    if (shuffle) {
      shuffle.addEventListener('click', function () {
        var g2 = group(2);
        var g3 = group(3);
        if (!g2 || !g3) return;
        var m = matrix();
        var pick = function (g) {
          var chips = g.querySelectorAll('[data-vpb-flavor]');
          return chips[Math.floor(Math.random() * chips.length)];
        };
        var c2, c3, tries = 0;
        do {
          c2 = pick(g2);
          c3 = pick(g3);
          tries++;
        } while (
          m && tries < 25 &&
          (!m[c2.dataset.value + '||' + c3.dataset.value] || !m[c2.dataset.value + '||' + c3.dataset.value].available)
        );
        setActive(g2, c2);
        setActive(g3, c3);
        state.v2 = c2.dataset.value;
        state.v3 = c3.dataset.value;
        setSlot(2, c2);
        setSlot(3, c3);
        announce('Surprise pack: ' + c2.dataset.value + ' and ' + c3.dataset.value);
        afterSelectionChange();
        [1, 2, 3].forEach(function (i) {
          stepDone[i] = true;
          var el = stepEl(i);
          if (el) el.classList.add('is-done');
        });
        openStep(0);
        if (form && typeof form.scrollIntoView === 'function') {
          form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }

    // ---- Quantity ----
    var qtyInput = root.querySelector('.pdp__qty-input');
    Array.prototype.forEach.call(root.querySelectorAll('[data-vpb-qty]'), function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        var val = parseInt(qtyInput.value, 10) || 1;
        if (btn.dataset.vpbQty === 'minus' && val > 1) val--;
        if (btn.dataset.vpbQty === 'plus') val++;
        qtyInput.value = val;
      });
    });

    // ---- Mobile sticky preview: measure header + preview heights ----
    var headerEl = document.querySelector('[data-header]');
    var previewEl = root.querySelector('.vpb__preview');
    function measureSticky() {
      var h = headerEl ? headerEl.getBoundingClientRect().height : 0;
      root.style.setProperty('--vpb-sticky-top', Math.round(h) + 'px');
      if (previewEl) root.style.setProperty('--vpb-preview-h', Math.round(previewEl.getBoundingClientRect().height) + 'px');
    }
    measureSticky();
    window.addEventListener('resize', measureSticky);
    window.addEventListener('load', measureSticky);

    // ---- Sticky bar ----
    var sticky = root.querySelector('[data-vpb-sticky]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var show = !en.isIntersecting && en.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
      }, { threshold: 0 });
      obs.observe(atc);
    }
    var stickyAtcBtn = root.querySelector('[data-vpb-sticky-atc]');
    if (stickyAtcBtn && form) {
      stickyAtcBtn.addEventListener('click', function () {
        if (atc && atc.disabled) return;
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });
    }
    Array.prototype.forEach.call(root.querySelectorAll('[data-vpb-sticky-plan]'), function (btn) {
      btn.addEventListener('click', function () {
        if (!subWidget) return;
        var target = subWidget.querySelector('[data-sub-option="' + btn.dataset.vpbStickyPlan + '"]');
        if (target) target.click();
      });
    });
    root.addEventListener('sub:change', function (e) {
      var kind = e.detail && e.detail.kind;
      Array.prototype.forEach.call(root.querySelectorAll('[data-vpb-sticky-plan]'), function (btn) {
        var on = btn.dataset.vpbStickyPlan === kind;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      updatePurchaseUI();
    });

    // ---- Init ----
    var a2 = activeChip(2);
    var a3 = activeChip(3);
    state.v2 = a2 ? a2.dataset.value : null;
    state.v3 = a3 ? a3.dataset.value : null;
    refreshAvailability();
    updateSavings();
    updatePurchaseUI();

    // Deep links (standalone page only):
    //   ?starter=<variety product handle>  pre-selects that 1st bag directly.
    //   ?bag1=<2kg bag flavour words>      (from the variety-pack bar on a 2kg
    //     PDP) fuzzy-matches the bag to a starter flavour, mirroring
    //     snippets/vpb-flavor-image.liquid: score each starter by how many of
    //     its flavour words appear in the bag text, preferring the starter
    //     whose words all matched (so "chicken adult" picks "Chicken", not
    //     "Chicken small bite"). Weak matches (one word of several, e.g.
    //     "Salmon & Potato" vs "Tuna & Salmon") leave the default in place.
    try {
      var params = new URLSearchParams(window.location.search);
      var wantHandle = params.get('starter');
      var wantBag = params.get('bag1');
      var target = null;
      if (root.dataset.baseUrl && wantHandle) {
        target = starters.filter(function (s) { return s.handle === wantHandle; })[0] || null;
      }
      if (root.dataset.baseUrl && !target && wantBag) {
        var norm = function (str) {
          return String(str || '').toLowerCase().replace(/[&(),\/+\-_]/g, ' ').replace(/\s+/g, ' ').trim();
        };
        var bagText = ' ' + norm(wantBag) + ' ';
        var best = null;
        var bestScore = 0;
        var bestRatio = 0;
        starters.forEach(function (s) {
          var label = norm(s.label);
          if (label.indexOf('sweet potato') !== -1) label = 'salmon small bite';
          var words = label.split(' ').filter(function (w) { return w && w !== 'and'; });
          if (!words.length) return;
          var score = words.filter(function (w) { return bagText.indexOf(' ' + w + ' ') !== -1; }).length;
          if (!score) return;
          var ratio = score / words.length;
          if (score > bestScore || (score === bestScore && ratio > bestRatio)) {
            best = s; bestScore = score; bestRatio = ratio;
          }
        });
        if (best && (bestRatio === 1 || bestScore >= 2)) target = best;
      }
      if (target && target.handle !== root.dataset.currentHandle) {
        var chip = root.querySelector('[data-vpb-starter="' + target.key + '"]');
        if (chip) chip.click();
      }
    } catch (e) { /* noop */ }
  })();
  } catch(e) { console.error(e); }
})();

})();
